$(document).ready(function() {

	// accordion
	$('.acc-item .acc-title').on('click', function(e){
    e.preventDefault();
    if($(this).parent().hasClass('active')) {
      $(this).parent().removeClass('active');
      $(this).next().slideUp(300);
    } else {
      $('.acc-item .acc-content').slideUp(300);
      $('.acc-item').removeClass('active');
      $(this).parent().addClass('active');
      $(this).next().slideDown(300);
    }
  });
	

	// popup
	$('.button[href="#apply-popup"]').on('click', function(e){
		e.preventDefault();
		$('#apply-popup').addClass('active');
	});

	$('.close-popup').on('click', function(){
		$(this).parent().parent().removeClass('active');
	});

    $('.hamburger').click(function(e){
        e.preventDefault();
		$(this).toggleClass('is-active');
		$('.mega-menu').toggleClass('active');
	});

	// menu
	$('.mega-menu-block-services .sub-links a').matchHeight();

	// add child classes
	$('.mega-menu-block').each(function(){
		var element = $(this).attr('data-menu-item');
		// console.log(element)
		$('.'+element).addClass('menu-item-has-children');
	});

	// open menu blocks
	$('.menu > li.menu-item-has-children > a').on('click', function(e){
		e.preventDefault();
		// var target = $(this).parent().attr('id');
		var classes = $(this).parent().attr('class').split(' ');
		var target = '';
		
		// Loop through each class and find the one that matches the pattern 'menu-item-<digits>'
		$.each(classes, function(index, className) {
		  if (/^menu-item-\d+$/.test(className)) {
			target = className;
			return false; // Break the loop once the desired class is found
		  }
		});
		// console.log(target);
		if($(this).parent().hasClass('menu-item-open')) {
			$('.menu > li').removeClass('menu-item-open');
			$('.menu').removeClass('menu-active');
			$('.mega-menu').removeClass('active');
			$('.mega-menu-block').removeClass('active');
			$('.hamburger').removeClass('is-active');
		} else {
			$('.menu > li').removeClass('menu-item-open');
			$('.mega-menu-block').removeClass('active');

			$(this).parent().addClass('menu-item-open');
			$('.mega-menu').addClass('active');
			$('.mega-menu-block[data-menu-item="'+target+'"]').addClass('active');
			$('.hamburger').addClass('is-active');
			$('.menu').addClass('menu-active');
		}
	});

	$('.menu-back').on('click', function(e){
		e.preventDefault();
		$('.menu > li').removeClass('menu-item-open');
		$('.mega-menu-block').removeClass('active');
		$('.menu').removeClass('menu-active');
	});

	$('.team .scroll-link').each(function(){
		$text = $(this).text();
		$(this).addClass($text);
	});

	$('.testimonial-slider__items').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		dots: false,
		autoplay: true,
		autoplaySpeed: 5000,
		pauseOnHover: false,
		fade: true, responsive: [

			{
				breakpoint: 600,
				settings: {
					//adaptiveHeight: true,
				}
			},

			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		]

	});

	$('.image-slider .slider').each(function() {
		const el = $(this);
		el.slick({
			centerMode: true,
			centerPadding: '100px',
			slidesToShow: 1,
			prevArrow: el.parent().find('.btn-prev'),
			nextArrow: el.parent().find('.btn-next'),
			responsive: [
				{
					breakpoint: 768,
					settings: {
						centerPadding: '30px'
					}
				}
			]
		});
	});


	$('.hero-slider').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: true,
		autoplay: true,
		autoplaySpeed: 10000,
		pauseOnHover: false,
		fade: true,
	});

	$('.scroll-links-slider').slick({
		infinite: true,
		slidesToShow: 6,
		slidesToScroll: 1,
		arrows: false,
		dots: false,
		swipeToSlide: true,
		responsive: [
			{
				breakpoint: 1400,
				settings: {
					slidesToShow: 5,
				}
			},
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 4,
				}
			},
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 3,
				}
			}
		]
	});

	$('.scroll-links-slider-alt').slick({
		infinite: true,
		slidesToShow: 5,
		slidesToScroll: 1,
		arrows: false,
		dots: false,
		swipeToSlide: true,
		responsive: [
			{
				breakpoint: 1400,
				settings: {
					slidesToShow: 5,
				}
			},
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 4,
				}
			},
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 3,
				}
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 2,
				}
			}
		]
	});

	// map
	$('.map-slider').on('afterChange', function(event, slick, currentSlide){
		var target = $('.map-slider .slick-active').attr('data-marker');
		$('.map .marker').removeClass('active');
		$(target).addClass('active');
		// console.log(target);
	});
	$('.map-slider').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		nextArrow: $('.map').find('.slick-next'),
		prevArrow: $('.map').find('.slick-prev'),
		dots: false,
	});

	$('.marker').on('click', function() {
		var markerId = $(this).attr('id');
		var slideIndex = $('.map-slider [data-marker="#' + markerId + '"]').data('slick-index');
		$('.map-slider').slick('slickGoTo', slideIndex);
	});

	$('.team-slider').slick({
		infinite: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: true,
		nextArrow: $('.team-section').find('.slick-next'),
		prevArrow: $('.team-section').find('.slick-prev'),
		dots: false,
		responsive: [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 3,
				}
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
				}
			},
		]
	});

	$('.post-slider').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		nextArrow: $('.post-slider-block').find('.slick-next'),
		prevArrow: $('.post-slider-block').find('.slick-prev'),
	});
	
	// Match height
$('.team-grid-slider').on('init', function(event, slick){
	setTimeout(function(){
		$('.team-item .text-wrap h3').matchHeight();
		$('.team-item .text-wrap .role').matchHeight();
	}, 1000);
});
$('.team-item .text-wrap h3').matchHeight();
$('.team-item .text-wrap .role').matchHeight();
setTimeout(function(){
	$('.team-item .text-wrap h3').matchHeight();
	$('.team-item .text-wrap .role').matchHeight();
}, 1000);

	$('.team-grid-slider').slick({
		infinite: false,
		slidesToShow: 4,
		slidesToScroll: 4,
		rows: 2,
		arrows: true,
		nextArrow: $('.team-section').find('.slick-next'),
		prevArrow: $('.team-section').find('.slick-prev'),
		responsive: [
			{
				breakpoint: 1023,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
				}
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
				}
			},
		]
	});

	  $('.scroll-link')
  // Remove links that don't actually link to anything
  // .not('[href="#"]')
  // .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
      && 
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate(
          {
            scrollTop: target.offset().top - 100
          },
          600
          );
      }
    }
	});
	
	// track record breadcrumb for sinlge track records
	var track_record = $('#breadcrumbs.track-record-bread a:contains("Live assignments")');
	track_record.text('Track Record');
	track_record.attr('href', '/track_record/track-record/');
	
	// add team page to team single in breadcrumb
	var teamLink = $('<span><a href="/about-us/our-team/">Our team</a></span>');
	var separator = $('<span class="separator">-</span>');
	$('.team-detail #breadcrumbs .breadcrumb_last').before(teamLink).before(separator);
	
	
	$('.assignment-item .text-wrap h3').matchHeight();
	$('.assignment-item .text-wrap ul').matchHeight();

	AOS.init();

	onElementHeightChange(document.body, function(){
      	AOS.refresh();
	});
});


$(document).click(function (e){
	var element = $(".menu > li > a, .mega-menu-block, .masthead, .mega-menu-nav");
	if (!element.is(e.target) && element.has(e.target).length === 0 ) {
		$('.masthead__nav .menu > li').removeClass('menu-item-open');
		$('.masthead__nav .menu').removeClass('menu-active');
		$('.mega-menu').removeClass('active');
		$('.mega-menu-block').removeClass('active');
		$('.hamburger').removeClass('is-active');
	}
	var el_2 = $('.button[href="#apply-popup"], .apply-popup-block');
	if (!el_2.is(e.target) && el_2.has(e.target).length === 0 ) {
		$('#apply-popup').removeClass('active');
	}
});

$('.mh-wrap').matchHeight();


$(window).on('scroll resize', function (event) {
    AOS.refresh();
});

// gform button class
$(document).on('gform_post_render', function(event, form_id, current_page){
	$('.form-wrapper').find('.button').addClass('fill');
	$('.brochure .form-wrapper').find('.button').addClass('alt');
	if($('.gfield-wrapper').length === 0) {
    	$('.apply-popup #field_2_6, .apply-popup #field_2_7, .apply-popup #field_2_8').wrapAll( '<div class="gfield-wrapper"><div class="gfield-wrapper-inner"></div></div>' );
	}	
});


// elements change heights aos

function onElementHeightChange(elm, callback) {
	  var lastHeight = elm.clientHeight
	  var newHeight;
	  
	  (function run() {
	      newHeight = elm.clientHeight;      
	      if (lastHeight !== newHeight) callback();
	      lastHeight = newHeight;
	
	      if (elm.onElementHeightChangeTimer) {
	        clearTimeout(elm.onElementHeightChangeTimer); 
	      }
	
	      elm.onElementHeightChangeTimer = setTimeout(run, 200);
	  })();
}

// header
$(window).on('load scroll', function(){
	var scroll = $(window).scrollTop();
	if(scroll >= 300) {
		$('.masthead').addClass('scrolled');
		setTimeout(function(){
			$('.mega-menu-block, .mega-menu-nav').css('padding-top', $('.masthead').outerHeight()+'px');
		},300);
	} else if(scroll < 200) {
		$('.masthead').removeClass('scrolled');
		setTimeout(function(){
			$('.mega-menu-block, .mega-menu-nav').css('padding-top', $('.masthead').outerHeight()+'px');
		},300);
	}
});

// header-padding
$(window).on('load resize scroll', function(){
	$('.mega-menu-block, .mega-menu-nav').css('padding-top', $('.masthead').outerHeight()+'px');
});

$(document).on('facetwp-loaded', function() {
	if (FWP.loaded && $('body.blog .post-listings').length) {
		$('html, body').animate({
			scrollTop: $('body.blog .post-listings').offset().top - 100
		}, 500);
	} else if(FWP.loaded && $('.search-results').length) {
		$('html, body').animate({
			scrollTop: $('.search-results').offset().top - 100
		}, 500);
	}
});